export const UserVipIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <mask id="mask0_130757_251886" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="2" width="16" height="14">
          <path d="M16.7627 2.44531H1.24219V15.5516H16.7627V2.44531Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_130757_251886)">
          <path d="M16.7627 6.96669L13.5238 2.44531H9.00244H4.48219L1.24219 6.96669L9.00244 15.5516L16.7627 6.96669Z" fill="#F3C600"/>
          <path d="M13.5238 2.44531H9.00244H4.48219L1.24219 6.96669H9.00244H16.7627L13.5238 2.44531Z" fill="#FFDF3E"/>
          <path d="M4.48438 2.44531L6.362 6.96669L9.00463 2.44531H4.48438Z" fill="#FFEE82"/>
          <path d="M13.5214 2.44531L11.6438 6.96669L9 2.44531H13.5214Z" fill="#FFEE82"/>
          <path d="M6.35938 6.96875H11.6458L9.002 15.5536L6.35938 6.96875Z" fill="#FFDE48"/>
          <path d="M12.6208 6.33594H11.1988L9.39544 9.44206L7.43006 6.33594H5.39719H5.13281V7.00531H5.82469L9.13781 12.1961L12.6208 6.33594Z" fill="#944806"/>
        </g>
      </svg>
    )
  },
})
